import { ColDef } from '@ag-grid-community/core';
import { formatColumnDate, headerInfoTooltipDef } from '../../lib/utils';
import formatDate from 'date-fns/format';
import parse from 'date-fns/parse';

export const ConferenceCall = [
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    field: 'ticker',
    width: 50,
    ...headerInfoTooltipDef('Symbol associated with the company who is having the conference call'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    cellStyle: { fontWeight: 'bold' },
    field: 'name',
    width: 200,
  },
  {
    cellClass: 'ticker-cell',
    field: 'date',
    headerName: 'Call Date',
    initialSort: 'asc' as ColDef['initialSort'],
    valueFormatter: ({ data }: any) => formatColumnDate(data.date),
    valueGetter: ({ data }: any) => {
      if (!data.date) return null;
      return data.date;
    },
    width: 80,
    ...headerInfoTooltipDef('Date of Call'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'start_time',
    headerName: 'Start Time',
    valueFormatter: ({ value }: any) => {
      if (!value) return '';
      return formatDate(value, 'h:mm a');
    },
    valueGetter: ({ data }: any) => {
      if (!data.start_time) return '';
      return parse(data.start_time, 'HH:mm:ss', new Date());
    },
    width: 70,
    ...headerInfoTooltipDef('Time of Call'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      if (!data.webcast_url) return '';
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href={data.webcast_url} target="_blank">
          ${data.webcast_url}
        </a>
      );
    },
    field: 'webcast_url',
    headerName: 'Webcast',
    width: 180,
    ...headerInfoTooltipDef('URL For Joining the Call’s Webcast'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      if (!data.phone_num) return '-';
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href={`tel:${data.phone_num}`} target="_blank">
          ${data.phone_num}
        </a>
      );
    },
    field: 'phone_num',
    headerName: 'Dial In',
    width: 60,
    ...headerInfoTooltipDef('Dial in number for participants outside of the US'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      if (!data.access_code) return '-';
      return data.access_code;
    },
    field: 'access_code',
    headerName: 'Access Code',
    width: 90,
    ...headerInfoTooltipDef('Code participants must type in to access call'),
  },
];
